
/*
Autor: Patrick Alex Maia Duarte
Ref Autor: https://patrickduarte.github.io
RDM:428
Ano: 2022
Objetivo: Listar os perfils cadastrados no sistema. Possui ações de desabilitar e habilitar, que afetam se o usuário vai ver ou não disponível
           no menu de acessos. Não permit operação de excluir, por questões de segurança.

*/

/**Vai fazer mudanças? Então identifique-se e descreva objetivo */

/**
 * Autor:
 * Ref Autor:
 * RDM:
 * Data:
 * Objetivo:
 */
import {computed,reactive,onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {Perfil} from "@/models/perfil";
import axios from "axios";

export default {
    name:"PerfilsTable",
    setup() {
        const perfils = ref<Perfil[]>([]);

        const acesso = reactive({
            btnInsert:false,
            btnAlter:false,
            btnDelete:false,
            
        });

        const filteredTable = ref(<any>[]);

        const dados = reactive({
            totalreg:0,     
        });
        const lastPage = ref( 0);
        const perPage = ref(9);
        const page = ref(1);

        const store = useStore();
        const userlogin = computed( () => store.state.user);

        const router = useRouter();
        const route = useRoute();

        onMounted( async () => {
            loadAcessos();
            loadtable();
         //   console.log(links.value);
        });

         const loadAcessos = async () => {
          //   console.log(userlogin.value.id);
        

            if (route.params.t=== 'f'){
                const resp = await axios.get(`btngetshowuserfunc/${route.params.id}/${userlogin.value.id}`);
                acesso.btnInsert = resp.data.insert === 1 ? true : false;
                acesso.btnAlter =  resp.data.update === 1 ? true : false;
                acesso.btnDelete = resp.data.delete === 1 ? true : false;
            }else if (route.params.t=== 'p'){

                const resp = await axios.get(`btngetshowperfilfunc/${route.params.id}/${route.params.perfil}`);
                acesso.btnInsert = resp.data.insert === 1 ? true : false;
                acesso.btnAlter =  resp.data.update === 1 ? true : false;
                acesso.btnDelete = resp.data.delete === 1 ? true : false;

            }else {
                acesso.btnInsert = false;
                acesso.btnAlter = false;
                acesso.btnDelete = false;
            }

        }

        const loadtable =async () => {
            const {data} = await axios.get('perfils');
            perfils.value = data;
        
            dados.totalreg = perfils.value.length;
          //  filteredTable.value = funcoes.value;

           filteredTable.value = perfils.value.slice(0, page.value * perPage.value);
           lastPage.value = Math.ceil(perfils.value.length / perPage.value);

        }

        const loadMore = () => {
          page.value = page.value + 1;
          lastPage.value = Math.ceil(perfils.value.length / perPage.value);
           filteredTable.value = perfils.value.slice(0, page.value * perPage.value);

      }

        const search = (s: string) => {

            filteredTable.value = perfils.value.filter(
                                                      p=> (p.short_name?p.short_name:'').toLowerCase().indexOf(s.toLowerCase()) >= 0 ||
                                                      (p.long_name?p.long_name:'').toLowerCase().indexOf(s.toLowerCase()) >= 0);
       
           
           lastPage.value = Math.ceil(filteredTable.value.length / perPage.value);
           filteredTable.value = filteredTable.value.slice(0, page.value * perPage.value);
        }

        const ativar = async (id: number) => {
                if (confirm('Deseja Ativar Perfil?')) {
                    await axios.put(`ativarperfil/${id}`);
                    loadtable();
                }
        }

        const inativar = async (id: number) => {
                if (confirm('Deseja Inativar Perfil?')) {
                    await axios.put(`inativarperfil/${id}`);
                    loadtable();
                }
        }

      const exportCSV = async () => {
            const {data} = await axios.post('perfilsexport', {}, {responseType: 'blob'});
            const blob = new Blob([data], {type: 'text/csv'});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(data);
            link.download = 'perfils.csv';
            link.click();
        }

        return {
            perfils,
            ativar,
            inativar,
            userlogin,
            acesso,
            filteredTable,
            search,
            lastPage,
            perPage,
            page,
            loadMore,
            dados,
            exportCSV,
            route          
        }
    }

}
